function TextLoader() {
  return (
    <div className='h-3 w-full animate-pulse cursor-wait rounded-full bg-loading' />
  );
}

export { TextLoader };
